function HandleError(error: any): void {
    console.error('Handle Error: ', error)

    // Sentry.captureException(error)
}

export default HandleError
